import styled from 'styled-components';
import colors from 'assets/styles/colors';
import SectionContainer from '../containers/SectionContainer';

export const BuyDeviceContainer = styled(SectionContainer)`
  background-color: ${colors.red};
  display: flex;
  align-items: center;
`;
